import { render, staticRenderFns } from "./ContraIndicationTest.vue?vue&type=template&id=49639d0a&scoped=true&"
import script from "./ContraIndicationTest.vue?vue&type=script&lang=js&"
export * from "./ContraIndicationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49639d0a",
  null
  
)

export default component.exports